module.exports = __webpack_public_path__ + "static/elephant-1-a3a3c6e5dbfe54c513f3e21b5666f9c9.jpg";